/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  CompanyMeeting,
  CompanyMeetingPreview,
  CompanyMeetingSummary,
  LogCompanyMeetingRequest,
  LogCompanyMeetingResponse,
  PreviewCompanyMeetingRequest,
  RecentJamieMeeting,
} from "../models/index";
import {
  CompanyMeetingFromJSON,
  CompanyMeetingToJSON,
  CompanyMeetingPreviewFromJSON,
  CompanyMeetingPreviewToJSON,
  CompanyMeetingSummaryFromJSON,
  CompanyMeetingSummaryToJSON,
  LogCompanyMeetingRequestFromJSON,
  LogCompanyMeetingRequestToJSON,
  LogCompanyMeetingResponseFromJSON,
  LogCompanyMeetingResponseToJSON,
  PreviewCompanyMeetingRequestFromJSON,
  PreviewCompanyMeetingRequestToJSON,
  RecentJamieMeetingFromJSON,
  RecentJamieMeetingToJSON,
} from "../models/index";

export interface GetCompanyMeetingRequest {
  companyMeetingId: string;
}

export interface ListMeetingsForCompanyRequest {
  companyId: string;
}

export interface LogCompanyMeetingOperationRequest {
  logCompanyMeetingRequest: LogCompanyMeetingRequest;
}

export interface PreviewCompanyMeetingOperationRequest {
  previewCompanyMeetingRequest: PreviewCompanyMeetingRequest;
}

/**
 *
 */
export class CompanyMeetingsApi extends runtime.BaseAPI {
  /**
   */
  async getCompanyMeetingRaw(
    requestParameters: GetCompanyMeetingRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CompanyMeeting>> {
    if (requestParameters["companyMeetingId"] == null) {
      throw new runtime.RequiredError(
        "companyMeetingId",
        'Required parameter "companyMeetingId" was null or undefined when calling getCompanyMeeting().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/company-meetings/{companyMeetingId}`.replace(
          `{${"companyMeetingId"}}`,
          encodeURIComponent(String(requestParameters["companyMeetingId"])),
        ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CompanyMeetingFromJSON(jsonValue),
    );
  }

  /**
   */
  async getCompanyMeeting(
    requestParameters: GetCompanyMeetingRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CompanyMeeting> {
    const response = await this.getCompanyMeetingRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async listMeetingsForCompanyRaw(
    requestParameters: ListMeetingsForCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<CompanyMeetingSummary>>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling listMeetingsForCompany().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/company-meetings/for-company`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CompanyMeetingSummaryFromJSON),
    );
  }

  /**
   */
  async listMeetingsForCompany(
    requestParameters: ListMeetingsForCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<CompanyMeetingSummary>> {
    const response = await this.listMeetingsForCompanyRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Snapshot one of the current user\'s Jamie meetings against a company and create todos from the confirmed action items. Fired when the rep attaches the meeting in the Log Sales Call dialog; the sales-call note links to the snapshot later, at save. Idempotent end to end.
   * Snapshot one of the current user\'s Jamie meetings against a company and create todos from the confirmed action items.
   */
  async logCompanyMeetingRaw(
    requestParameters: LogCompanyMeetingOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<LogCompanyMeetingResponse>> {
    if (requestParameters["logCompanyMeetingRequest"] == null) {
      throw new runtime.RequiredError(
        "logCompanyMeetingRequest",
        'Required parameter "logCompanyMeetingRequest" was null or undefined when calling logCompanyMeeting().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/company-meetings/log`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: LogCompanyMeetingRequestToJSON(
          requestParameters["logCompanyMeetingRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      LogCompanyMeetingResponseFromJSON(jsonValue),
    );
  }

  /**
   * Snapshot one of the current user\'s Jamie meetings against a company and create todos from the confirmed action items. Fired when the rep attaches the meeting in the Log Sales Call dialog; the sales-call note links to the snapshot later, at save. Idempotent end to end.
   * Snapshot one of the current user\'s Jamie meetings against a company and create todos from the confirmed action items.
   */
  async logCompanyMeeting(
    requestParameters: LogCompanyMeetingOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<LogCompanyMeetingResponse> {
    const response = await this.logCompanyMeetingRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Fetch + parse one of the current user\'s meetings for review. Does not persist.
   * Fetch + parse one of the current user\'s meetings for review.
   */
  async previewCompanyMeetingRaw(
    requestParameters: PreviewCompanyMeetingOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CompanyMeetingPreview>> {
    if (requestParameters["previewCompanyMeetingRequest"] == null) {
      throw new runtime.RequiredError(
        "previewCompanyMeetingRequest",
        'Required parameter "previewCompanyMeetingRequest" was null or undefined when calling previewCompanyMeeting().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/company-meetings/preview`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: PreviewCompanyMeetingRequestToJSON(
          requestParameters["previewCompanyMeetingRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CompanyMeetingPreviewFromJSON(jsonValue),
    );
  }

  /**
   * Fetch + parse one of the current user\'s meetings for review. Does not persist.
   * Fetch + parse one of the current user\'s meetings for review.
   */
  async previewCompanyMeeting(
    requestParameters: PreviewCompanyMeetingOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CompanyMeetingPreview> {
    const response = await this.previewCompanyMeetingRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * The current user\'s recent Jamie meetings, to pick one to log. Scoped to the logged-in user --- you never see anyone else\'s meetings.
   * The current user\'s recent Jamie meetings, to pick one to log.
   */
  async recentCompanyMeetingsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<RecentJamieMeeting>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/company-meetings/recent-meetings`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(RecentJamieMeetingFromJSON),
    );
  }

  /**
   * The current user\'s recent Jamie meetings, to pick one to log. Scoped to the logged-in user --- you never see anyone else\'s meetings.
   * The current user\'s recent Jamie meetings, to pick one to log.
   */
  async recentCompanyMeetings(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<RecentJamieMeeting>> {
    const response = await this.recentCompanyMeetingsRaw(initOverrides);
    return await response.value();
  }
}
